export default  [
        {
            category: 'Usuario',
            pages: [

              { name: 'intranet/*', path: '/user/Intranet' },
              { name: 'noticia/*', path: '/user/Noticia' },


            ],
          roles: ['manager']
        },
  {
    category: 'Setting',
    pages: [

      { name: 'account/*', path: '/setting/Account' },
      { name: 'session/*', path: '/setting/Session' },


    ],
    roles: ['manager']
  },
        {
          category: 'Administración',
          pages: [
            { name: 'usuario', path: '/admin/Usuarios' },
            { name: 'administrar', path: '/admin/Administrar' },
            { name: 'consola', path: '/admin/Intranet' },
            { name: 'informe', path: '/admin/Informe' },
            { name: 'usuarios', path: '/admin/usuarios' },
                {
                  category: 'Otra',
                  pages: [

                    { name: 'Test 1', path: '/admin/locales' },
                    { name: 'Test 2', path: '/admin/animales' },

                  ],
                  roles: ['admin']
                },
          ],
          roles: ['admin']
        },

    ]



// WEBPACK FOOTER //
// ./src/menu.js